module.exports = __webpack_public_path__ + "media/img/frontend_application/content_production/client_9-1680f6d0470cc7655fe55fcbeca55bbe.png";